import * as React from 'react'
import { connect } from 'react-redux'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Container } from '@amzn/dvui/dist/Container'
import { Text } from '@amzn/dvui/dist/Text'
import * as st from './contactUs.module.scss'
import * as stUtility from '../utilityClasses.module.scss'
import { ContactUsBox } from './contactUsBox'
import { IDetailPageState } from '../../reducers'


export interface IContactUsProps {
  useContactUs: boolean,
  contactUs?: WpsRuntime.atv.wps.ContactUsModelProps
}

export const ConnectedContactUs = ({ contactUs, useContactUs }: IContactUsProps) =>
  useContactUs && contactUs && contactUs.contactUsBoxList && contactUs.contactUsBoxList.length ? (
    <Container className={`${stUtility.pageSection} ${st.contactUs}`}>
      <span data-automation-id="av-contact-us">
        <div id="contactus" className={st.contactUsHeader}>
          <h1><Text string={contactUs.header}/></h1>
        </div>
        <div className={st.contactUsBody}>
          {contactUs.contactUsBoxList.map((box, idx) =>
            <ContactUsBox {...box} key={`contact-us-${idx}`}/>)}
        </div>
      </span>
    </Container>) : null

const mapStateToProps = (state: IDetailPageState): IContactUsProps => ({
  useContactUs: Boolean(state.features.useContactUs),
  contactUs: state.contactUs[state.pageTitleId]
})

export const ContactUs = connect(mapStateToProps)(
  ConnectedContactUs
)

